import { apiClient } from "../../utils/apiClient";
import { Persona } from "../../types/persona";
import { PersonaSQL } from "../../types/PersonaSQL";

//Personas de Oracle
export const fetchPersonas = async (cedula: string): Promise<Persona[]> => {
  return apiClient
    .get(`/appointments/personasPadron?cedula=${cedula}`)
    .then((response) => response.data);
};

//Personas de SQK (nuevo: 06/03/2026)
export const fetchPersonasSQL = async (
  searchTerm: string,
  options?: { signal?: AbortSignal },
): Promise<{
  message: string;
  records: number;
  success: boolean;
  data: PersonaSQL[];
  sugerencia: string;
}> => {
  // Usar encodeURIComponent para manejar caracteres especiales en la URL
  const url = `/personas/personasPadronSQL?searchTerm=${encodeURIComponent(searchTerm)}`;

  return apiClient
    .get(url, { signal: options?.signal })
    .then((response) => response.data)
    .catch((error) => {
      // Si la solicitud fue cancelada, propagar el error para manejarlo en el componente
      if (error.name === "AbortError" || error.code === "ERR_CANCELED") {
        throw error;
      }
      console.error("Error en fetchPersonasSQL:", error);
      throw error;
    });
};

export const postPersona = async (persona: PersonaSQL): Promise<any> => {
  const response = await apiClient.post("/personas", persona);
  return response.data;
};
